export const getNameFromCategorySlug = (slug: string) => {
  if (slug === 'interior') return 'Interiør';
  if (slug === 'hagemobler') return 'Hagemøbler';
  if (slug === 'mobelpleie') return 'Møbelpleie';
  if (slug === 'flere-rom') return 'Flere rom';
  if (slug === 'dekor-bruks-og-pyntegjenstander')
    return 'Dekor, bruks og pyntegjenstander';
  if (slug === 'tv-benk-tv-bord-og-mediamobler')
    return 'TV-benk, TV-bord og mediamøbler';
  if (slug === 'puff-benk-og-paller') return 'Puff, benk og paller';
  if (slug === 'hagetilbehor') return 'Hagetilbehør';
  if (slug === 'utekjokken') return 'Utekjøkken';

  return slug.split('-').join(' ');
};
